import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-remove-organisation',
  standalone: false,
  template: `
  <div style="background-color: var(--UI-Pastellbl); margin-bottom: 2rem; padding: 1rem; border-radius: 8px">Är du säker på att du vill ta bort organisationstillhörigheten?</div>
    <div class="d-flex justify-content-between">
      <app-button text="Avbryt" buttonStyle="secondary" (click)="cancel()"></app-button>
      <app-button text="Ta bort" icon="trash" buttonStyle="primary" (click)="confirm()"></app-button>
    </div>
  `,
})
export class ConfirmRemoveOrganisationComponent {
  private dialogRef = inject(DynamicDialogRef<ConfirmRemoveOrganisationComponent>);

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
